import { render } from "./FadeTransition.vue?vue&type=template&id=1b676cc7"
import script from "./FadeTransition.vue?vue&type=script&lang=js"
export * from "./FadeTransition.vue?vue&type=script&lang=js"

import exportComponent from "/web/markle/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"FadeTransition.vue"]])

export default __exports__